import React from 'react'
import { ReactComponent as ChildIcon } from '../../../../../../../assets/images/child-icon.svg'
import { ReactComponent as FamilyIcon } from '../../../../../../../assets/images/family-icon.svg'
import { ReactComponent as WeddingRingIcon } from '../../../../../../../assets/images/wedding-ring-icon.svg'
import { FamilyTreeResult } from './hooks'

export const RELATIONSHIP_ICON_MAPPING: { [key: string]: any } = {
  son: ChildIcon,
  daughter: ChildIcon,
  wife: WeddingRingIcon,
  husband: WeddingRingIcon,
  spouse: WeddingRingIcon,
  child: ChildIcon,
}

export interface FamilyResultViewProps {
  familyResult: FamilyTreeResult
  className?: string
}

export const FamilyResultView: React.FC<FamilyResultViewProps> = ({ familyResult, className }) => {
  const { relationship, name } = familyResult
  const RelationshipIcon = (relationship && RELATIONSHIP_ICON_MAPPING[relationship.toLowerCase()]) || FamilyIcon
  return (
    <div className={`family-result-container d-flex flex-column gap-3 align-items-center ${className && className}`}>
      <div className='family-result-container__img-container'>
        <i className='bi bi-person-fill' />
      </div>
      <div className='d-flex flex-grow-1 flex-column align-items-center justify-content-between'>
        <div className='d-flex align-items-center justify-content-center text-center bold'>{name}</div>
        <div className='d-flex gap-1 align-items-center'>
          <RelationshipIcon width='1rem' height='1rem' />
          {relationship ?? 'Unknown'}
        </div>
      </div>
    </div>
  )
}
